
(function () {
  'use strict';

  var carouselSelector = '[data-mg-purchase-carousel]';
  var slideSelector = '[data-mg-purchase-slide]';
  var intervalDuration = 5000;

  function initialiseCarousel(carousel) {
    if (carousel.dataset.mgCarouselInitialised === 'true') {
      return;
    }

    var slidesContainer = carousel.querySelector(
      '.mg-purchase-carousel__slides'
    );
    var controls = carousel.querySelector(
      '[data-mg-carousel-controls]'
    );
    var dotsContainer = carousel.querySelector(
      '[data-mg-carousel-dots]'
    );
    var previousButton = carousel.querySelector(
      '[data-mg-carousel-prev]'
    );
    var nextButton = carousel.querySelector(
      '[data-mg-carousel-next]'
    );

    if (!slidesContainer || !controls || !dotsContainer) {
      return;
    }

    var slides = Array.prototype.slice.call(
      slidesContainer.querySelectorAll(slideSelector)
    );

    if (slides.length === 0) {
      carousel.hidden = true;
      return;
    }

    carousel.dataset.mgCarouselInitialised = 'true';

    var currentIndex = 0;
    var timer = null;
    var touchStartX = null;

    slides.forEach(function (slide, index) {
      var dot = document.createElement('button');

      dot.type = 'button';
      dot.className = 'mg-purchase-carousel__dot';
      dot.setAttribute('aria-label', 'Show information ' + (index + 1));
      dot.addEventListener('click', function () {
        showSlide(index);
        restartTimer();
      });

      dotsContainer.appendChild(dot);
    });

    var dots = Array.prototype.slice.call(
      dotsContainer.querySelectorAll('.mg-purchase-carousel__dot')
    );

    function showSlide(index) {
      currentIndex = (index + slides.length) % slides.length;

      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === currentIndex;

        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === currentIndex;

        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });

      controls.hidden = slides.length < 2;

      if (previousButton) {
        previousButton.disabled = slides.length < 2;
      }

      if (nextButton) {
        nextButton.disabled = slides.length < 2;
      }
    }

    function stopTimer() {
      if (timer !== null) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function startTimer() {
      stopTimer();

      if (slides.length < 2) {
        return;
      }

      timer = window.setInterval(function () {
        showSlide(currentIndex + 1);
      }, intervalDuration);
    }

    function restartTimer() {
      startTimer();
    }

    if (previousButton) {
      previousButton.addEventListener('click', function () {
        showSlide(currentIndex - 1);
        restartTimer();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        showSlide(currentIndex + 1);
        restartTimer();
      });
    }

    carousel.addEventListener(
      'touchstart',
      function (event) {
        if (event.touches.length === 1) {
          touchStartX = event.touches[0].clientX;
        }
      },
      { passive: true }
    );

    carousel.addEventListener(
      'touchend',
      function (event) {
        if (touchStartX === null || !event.changedTouches.length) {
          return;
        }

        var touchEndX = event.changedTouches[0].clientX;
        var difference = touchEndX - touchStartX;
        touchStartX = null;

        if (Math.abs(difference) < 40 || slides.length < 2) {
          return;
        }

        showSlide(difference < 0 ? currentIndex + 1 : currentIndex - 1);
        restartTimer();
      },
      { passive: true }
    );

    showSlide(0);
    startTimer();
  }

  function initialiseAllCarousels() {
    document.querySelectorAll(carouselSelector).forEach(
      initialiseCarousel
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialiseAllCarousels
    );
  } else {
    initialiseAllCarousels();
  }

  document.addEventListener('shopify:section:load', function () {
    initialiseAllCarousels();
  });
})();
